import Plot from "react-plotly.js";
import React from "react";

const TickerWeightChart = ({ stocks }) => {
  // Sort stocks by weight in descending order and adjust weight to percentages
  const sortedStocks = [...stocks].map(stock => ({ ...stock, wgt: stock.wgt * 100 })).sort((a, b) => b.wgt - a.wgt);

  // Calculate cumulative weights and assign to intervals
  let cumulativeWeight = 0;
  const intervalCounts = Array(10).fill(0);
  const cumulativeCounts = Array(10).fill(0); // Array for the cumulative counts for stacking

  sortedStocks.forEach(stock => {
    cumulativeWeight += stock.wgt;
    const intervalIndex = Math.min(Math.floor(cumulativeWeight / 10), 9);
    intervalCounts[intervalIndex]++;
  });

  // Compute cumulative counts for stacking
  let runningTotal = 0;
  for (let i = 0; i < intervalCounts.length-1; i++) {
    runningTotal += intervalCounts[i];
    cumulativeCounts[i] = runningTotal;
  }
  // cumulativeCounts[cumulativeCounts.length-1] = 0

  // Define labels for cumulative weight intervals
  const intervalLabels = Array.from({ length: 10 }, (_, i) => `${i * 10}-${(i + 1) * 10}%`).reverse()
  const reversedCounts = intervalCounts.reverse();
  const reversedCumCounts = cumulativeCounts.reverse();
  return (
    <Plot
      data={[
        {
          x: reversedCounts, // Counts for each interval
          y: intervalLabels, // Labels for intervals
          type: 'bar',
          orientation: 'h', // Horizontal bar chart
          name: 'Interval Count',
            marker: {
            color: '#009bff', // Solid color with opacity
            line: { color: 'rgba(0, 0, 102, 0.06)', width: 0 }  // Outline for gradient effect
          }
        },
        {
          x: reversedCumCounts, // Cumulative counts for each interval
          y: intervalLabels, // Same labels for intervals
          type: 'bar',
          orientation: 'h',
          name: 'Cumulative Count',
              marker: {
            color: '#bddcf0', // Different color for the cumulative count
            line: { color: 'rgba(11, 81, 104 , 1)', width: 0 }, // Darker outline for gradient
            gradient: { color: 'none' } // Apply a gradient if needed
          },
          opacity: 1  // Adjust opacity to differentiate
        },
      ]}
      layout={{
        barmode: 'stack',  // Set to stack bars
        xaxis: {
          title: 'Number of Tickers',
          automargin: true
        },
        yaxis: {
          automargin: true
        },
        margin: { l: 20, r: 10, t: 20, b: 30 },
        showlegend: false,  // Show legend to differentiate bars
        responsive: true,
        autosize: true,
      }}
      useResizeHandler
      style={{ width: 300, height: 300 }}
    />
  );
};

export default TickerWeightChart;